import { privateInstance } from "../configs";

export const recipeCategoryApi = {
  async getRecipeCategories() {
    const res = await privateInstance.get(`/recipes/api/categories/list/`);
    return res.data;
  },
  async postRecipeCategory(category) {
    const res = await privateInstance.post(
      `/recipes/api/categories/list/`,
      category
    );
    return res.data;
  },
  async retrieveRecipeCategory(id) {
    const res = await privateInstance.get(`categories/${id}/`);
    return res.data;
  },
  async putRecipeCategory(id, category) {
    const res = await privateInstance.put(`categories/${id}/`, category);
    return res.data;
  },
  async patchRecipeCategory(id, category) {
    const res = await privateInstance.patch(`categories/${id}/`, category);
    return res.data;
  },
  async deleteRecipeCategory(id) {
    const res = await privateInstance.delete(`categories/${id}/`);
    return res.data;
  }
};
